(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["capoo-explore-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('capoo-explore')) {
  customElements.define('capoo-explore', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.opener = document.querySelector(`[data-capoo-menu-open][aria-controls="${this.dialog.id}"]`);
      if (!this.opener || !this.dialog.showModal) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.opener.addEventListener('click', event => { event.preventDefault(); this.dialog.showModal(); this.opener.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('capoo-explore-open'); this.querySelector('[data-capoo-menu-close]').focus(); }, options);
      this.querySelector('[data-capoo-menu-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => { if(event.target === this.dialog) { const bounds = this.dialog.getBoundingClientRect(); if(event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close(); } }, options);
      this.dialog.addEventListener('close', () => { this.opener.setAttribute('aria-expanded','false'); document.documentElement.classList.remove('capoo-explore-open'); this.dialog.classList.remove('is-drilled'); this.opener.focus(); }, options);
      this.querySelectorAll('[data-capoo-panel]').forEach(button => button.addEventListener('click', () => { const panel = button.dataset.capooPanel; this.querySelectorAll('[data-capoo-panel]').forEach(item => { const active = item === button; item.classList.toggle('is-active',active); item.setAttribute('aria-expanded',String(active)); }); this.querySelectorAll('[data-capoo-panel-content]').forEach(item => { item.hidden = item.dataset.capooPanelContent !== panel; }); this.dialog.classList.add('is-drilled'); this.querySelector('.capoo-explore__gallery').scrollTop = 0; if(matchMedia('(max-width:749px)').matches) this.querySelector('[data-capoo-menu-back]').focus(); }, options));
      this.querySelector('[data-capoo-menu-back]').addEventListener('click', () => { this.dialog.classList.remove('is-drilled'); this.querySelector('.capoo-explore__nav.is-active').focus(); }, options);
      this.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.dialog.close(), options));
    }
    disconnectedCallback() { this.abort?.abort(); document.documentElement.classList.remove('capoo-explore-open'); this.ready = false; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["capoo-market-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('capoo-market-carousel')) {
  customElements.define('capoo-market-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.capoo-market-carousel__track');
      this.toggle = this.querySelector('[data-market-pause]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.visible = false;
      this.hovered = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-market-previous]').addEventListener('click', () => { this.setPaused(true); this.advance(-1); }, options);
      this.querySelector('[data-market-next]').addEventListener('click', () => { this.setPaused(true); this.advance(1); }, options);
      this.toggle.addEventListener('click', () => this.setPaused(!this.paused), options);
      this.track.addEventListener('pointerdown', () => this.setPaused(true), options);
      this.track.addEventListener('wheel', () => this.setPaused(true), { ...options, passive: true });
      this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.reducedMotion.addEventListener('change', event => { if (event.matches) this.setPaused(true); }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: .2 });
      this.observer.observe(this);
      this.setPaused(this.paused);
      this.timer = window.setInterval(() => {
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement)) this.advance(1);
      }, 2500);
    }
    setPaused(paused) {
      this.paused = paused;
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      this.toggle.querySelector('[data-market-pause-icon]').toggleAttribute('hidden', paused);
      this.toggle.querySelector('[data-market-play-icon]').toggleAttribute('hidden', !paused);
    }
    advance(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      const max = this.track.scrollWidth - this.track.clientWidth;
      let target = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= max - 3) target = 0;
      if (direction < 0 && this.track.scrollLeft <= 3) target = max;
      this.track.scrollTo({ left: target, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
